<template>
  <div>
    <NavigationBreadcrumb :items="breadcrumb_items"></NavigationBreadcrumb>
    <div>
      <h3 class="title-header noprint mt-3">
        {{
          $getVisibleNames(
            "mesh.methodologicalstrategy",
            true,
            "Estrategias Metodológicas"
          )
        }}
        <AlternativeNameButton
          :table_name="'mesh.methodologicalstrategy'"
          :allows_crud="allows_crud"
        ></AlternativeNameButton>
      </h3>
      <div style="display: flex">
        <div class="col" style="text-align: left">
          <ButtonMedium
            v-can="'mesh.add_methodologicalstrategy'"
            v-if="allows_crud"
            :tooltip_text="
              $t('reusable.common.addTooltip', {
                entity: $getVisibleNames(
                  'mesh.methodologicalstrategy',
                  false,
                  'Estrategia Metodológica'
                ),
              })
            "
            :text_button="$t('reusable.common.add')"
            :click_button="
              () => $bvModal.show(`new-methodological-strategy-modal`)
            "
            :icon="'plus'"
            :variant="'primary'"
          >
          </ButtonMedium>
        </div>
      </div>
      <GenericBTable
        :items="methodological_strategies"
        :fields="methodologicalStrategyFields"
        :filter="input_search"
        :filterCustom="filterCustom"
        @emitChangeSearchField="changeInputSearch"
        :show_pagination="true"
        :search_filter="true"
        :columns_display="true"
        :allows_crud="allows_crud"
        :display_id="'methodological_strategies'"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
      >
        <template #cell(description)="row">
          <RenderVHtml :content="row.item.description"></RenderVHtml>
        </template>
        <template v-if="allows_crud" #cell(actions)="row">
          <ButtonSmall
            v-can="'mesh.change_methodologicalstrategy'"
            :tooltip_text="
              $t('reusable.common.editTooltip', {
                entity: $getVisibleNames(
                  'mesh.methodologicalstrategy',
                  false,
                  'Estrategia Metodológica'
                ),
              })
            "
            :click_button="
              () =>
                $bvModal.show(
                  `edit-methodological-strategy-modal-${row.item.id}`
                )
            "
            :class="``"
            :icon="'square'"
          ></ButtonSmall>
          <ButtonSmall
            v-can="'mesh.delete_methodologicalstrategy'"
            :click_button="
              () => askForDeleteMethodologicalStrategy(row.item.id)
            "
            :tooltip_text="
              $t('reusable.common.deleteTooltip', {
                entity: $getVisibleNames(
                  'mesh.methodologicalstrategy',
                  false,
                  'Estrategia Metodológica'
                ),
              })
            "
            :icon="'trash'"
          ></ButtonSmall>
          <b-modal
            :id="`edit-methodological-strategy-modal-${row.item.id}`"
            :title="
              $t('reusable.common.editModalTitle', {
                entity: $getVisibleNames(
                  'mesh.methodologicalstrategy',
                  false,
                  'Estrategia Metodológica'
                ),
              })
            "
            size="lg"
            hide-footer
          >
            <MethodologicalStrategyForm
              :MethodologicalStrategy="row.item"
              @updated="slotUpdatedMethodologicalStrategy"
              :institution_id="row.item.school"
              :show_title="false"
            ></MethodologicalStrategyForm>
          </b-modal>
        </template>
      </GenericBTable>
    </div>
    <b-modal
      :id="`new-methodological-strategy-modal`"
      :hide-footer="true"
      :title="
        $t('reusable.common.createModalTitle', {
          entity: $getVisibleNames(
            'mesh.methodologicalstrategy',
            false,
            'Estrategia Metodológica'
          ),
        })
      "
      size="lg"
    >
      <MethodologicalStrategyForm
        v-if="user"
        @created="slotCreatedMethodologicalStrategy"
        :institution_id="user.school"
      ></MethodologicalStrategyForm>
    </b-modal>
  </div>
</template>
<script>
import * as names from "@/store/names";
import { mapGetters } from "vuex";
import { toast } from "@/utils/utils";

export default {
  name: "MethodologicalStrategyView",
  components: {
    MethodologicalStrategyForm: () => import("./MethodologicalStrategyForm"),
    GenericBTable: () => import("@/components/reusable/GenericBTable"),
    AlternativeNameButton: () =>
      import("@/components/reusable/AlternativeNameButton"),
    ButtonSmall: () =>
      import("@/components/reusable/Buttons/Small/ButtonSmall"),
    ButtonMedium: () =>
      import("@/components/reusable/Buttons/Medium/ButtonMedium"),
    RenderVHtml: () => import("@/components/reusable/RenderVHtml"),
    NavigationBreadcrumb: () =>
      import("@/components/reusable/NavigationBreadcrumb"),
  },
  data() {
    return {
      input_search: "",
      sortBy: "",
      sortDesc: false,
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      methodological_strategies: names.METHODOLOGICAL_STRATEGIES,
    }),
    breadcrumb_items() {
      return [
        { text: this.$t("reusable.breadcrumb.home"), to: "/home" },
        {
          text: this.$getVisibleNames(
            "mesh.methodologicalstrategy",
            true,
            "Estrategias Metodológicas"
          ),
        },
      ];
    },
    allows_crud() {
      const has_permission = this.$hasPermissions(
        "mesh.add_methodologicalstrategy"
      );
      if (has_permission) return has_permission;
      else return false;
    },
    methodologicalStrategyFields() {
      return [
        {
          key: "name",
          label: String(
            this.$getVisibleNames(
              "mesh.methodologicalstrategy",
              true,
              "Estrategias Metodológicas"
            )
          ),
          sortable: true,
          display_column: true,
          tdClass: "text-left",
        },
        {
          key: "description",
          label: this.$t("reusable.common.description"),
          sortable: true,
          display_column: true,
          tdClass: "text-left",
        },
        {
          key: "is_active",
          label: this.$t("toolbar.methodologicalStrategy.validity"),
          sortable: true,
          formatter: (value) => {
            return value
              ? this.$t("reusable.common.yes")
              : this.$t("reusable.common.no");
          },
          display_column: true,
          thClass: "text-left",
          tdClass: { background: "var(--primary-color) !important" },
        },
        {
          key: "actions",
          label: "",
          display_column: true,
          thClass: "noprint",
          tdClass: "noprint",
        },
      ];
    },
  },
  methods: {
    filterCustom(row) {
      if (
        this.$filtered(row.name, this.input_search) ||
        this.$filtered(row.description, this.input_search) ||
        this.$filtered(
          row.is_active
            ? this.$t("reusable.common.yes")
            : this.$t("reusable.common.no"),
          this.input_search
        )
      ) {
        return true;
      } else return false;
    },
    changeInputSearch(input_search) {
      this.input_search = input_search;
    },
    slotCreatedMethodologicalStrategy() {
      this.$bvModal.hide("new-methodological-strategy-modal");
    },
    slotUpdatedMethodologicalStrategy(methodological_strategy) {
      this.$bvModal.hide(
        `edit-methodological-strategy-modal-${methodological_strategy.id}`
      );
    },
    askForDeleteMethodologicalStrategy(methodological_strategy_id) {
      this.$swal({
        title: this.$t("reusable.common.deleteConfirmTitle", {
          entity: this.$getVisibleNames(
            "mesh.methodologicalstrategy",
            false,
            "Estrategia Metodológica"
          ),
        }),
        text: this.$t("reusable.common.deleteConfirmText"),
        type: "warning",
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch(
              names.DELETE_METHODOLOGICAL_STRATEGY,
              methodological_strategy_id
            )
            .then(() => {
              toast(
                this.$getVisibleNames(
                  "mesh.methodologicalstrategy",
                  false,
                  "Estrategia Metodológica"
                ) +
                  " " +
                  this.$t("reusable.common.deleted")
              );
            });
        }
      });
    },
  },
  beforeDestroy() {
    this.$store.commit(names.MUTATE_DELETE_FILTER_INTELLIGENCE);
    this.$store.commit(names.MUTATE_SHOW_INTELLIGENCE_SIDEBAR, false);
    this.$store.commit(names.MUTATE_DELETE_RULES_FILTER_SELECTOR);
  },
  mounted() {},
  created() {
    this.sortBy = "name";
    this.$store.dispatch(names.FETCH_METHODOLOGICAL_STRATEGIES);
    this.$nextTick(() => {
      this.$store.commit(names.MUTATE_SHOW_INTELLIGENCE_SIDEBAR, true);
      this.$store.commit(names.MUTATE_RULES_FILTER_SELECTOR, {
        visible_intelligence_options: [7],
        disabled_selected_intelligence_option: true,
      });
      this.$store.commit(names.MUTATE_FILTER_INTELLIGENCE, {
        intelligence_option: 7,
      });
    });
  },
};
</script>
<style scoped>
.title-header {
  padding: 0 2rem;
}
.btn-add {
  margin-left: 0.4rem;
  margin-bottom: 0.5rem;
  border-radius: 8px;
  width: 255px;
}
</style>